<div class="flex flex-col gap-2">
  <label for="budget-estimate" class="text-sm font-semibold">{{ label || '' | translate }}</label>
  <p-inputgroup>
    <p-inputnumber id="budget-estimate" inputStyleClass="text-right" [ngModel]="value | async" [disabled]="true" />
    <p-inputgroup-addon>
      <i class="pi pi-calculator"></i>
    </p-inputgroup-addon>
  </p-inputgroup>
</div>
